export interface GetCompanyListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetCompanyListPagingAndFilterResponseData
}

export interface GetCompanyListPagingAndFilterResponseData {
    items: GetCompanyListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetCompanyListPagingAndFilterResponseItem {
    companyId: string
    parentCompanyId?: string
    code: string
    name: string
    longName: string
    phone1?: string
    email?: string
    description?: string
    isBlocked: boolean
    blockedDescription?: string
    isCustomActive: boolean
    logo: string
    isCustomer: boolean
    customerIntegrationCode: any
    isSupplier: boolean
    supplierIntegrationCode?: string
    isAgency: boolean
    agencyIntegrationCode: any
    isSenderFirm: boolean
    isReceiverFirm: boolean
    isDutyFirm: boolean
    isAirlineFirm: boolean
    isSeawayFirm: boolean
    commercialTypeId?: string
    tckn?: string
    vkn: any
    taxOffice?: string
    paymentTypeId?: string
    maturityPeriodId?: string
    invoiceCurrencyTypeId?: string
    eArchiveTypeId?: string
    eArchiveSendTypeId?: string
    abnNumber?: string
    mernisNo?: string
    paymentTypeName?: string
    maturityPeriodName?: string
    invoiceCurrencyTypeName?: string
    eArchiveTypeName?: string
    eArchiveSendTypeName?: string
    commercialTypeName?: string
    /** Firma durumu (MEETING_COMPANY_TYPE), ör. Çalışılan Müşteri. */
    initialCompanyTypeName?: string
    companyAddresses: GetCompanyListPagingAndFilterResponseCompanyAddress[]
    companyAuthorizedPersons: GetCompanyListPagingAndFilterResponseCompanyAuthorizedPerson[]
    companyBanks: GetCompanyListPagingAndFilterResponseCompanyBank[]
    fileArchives: GetCompanyListPagingAndFilterResponseFileArc[]
    isB2c: boolean
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export interface GetCompanyListPagingAndFilterResponseCompanyAddress {
    companyAddressId: string
    companyId: string
    addressTypeId: string
    addressText: string
    districtId: string
    isCustomActive: boolean
    isDefault: boolean
    addressTypeName: string
    districtName: string
    countyId: string
    countyName: string
    countryId: string
    countryName: string
    postalCode: string
}

export interface GetCompanyListPagingAndFilterResponseCompanyAuthorizedPerson {
    companyAuthorizedPersonId: string
    companyId: string
    name: string
    surname: string
    departmentId: string
    phone1: string
    phone2: string
    description: string
    isCustomActive: boolean
    departmentName: any
}

export interface GetCompanyListPagingAndFilterResponseCompanyBank {
    companyBankId: string
    companyId: string
    iban: string
    accountNo: string
    bankId: string
    currencyTypeId: string
    bankName: string
    currencyTypeName: string
}

export interface GetCompanyListPagingAndFilterResponseFileArc {
    fileArchiveId: string
    entityId: string
    fileName: string
    url: string
    fileTypeId: string
    description: string
    fileTypeName: string
    createdDate: string
}

export const initialGetCompanyListPagingAndFilterResponseData: GetCompanyListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}